import root from './_root.js';

/** Built-in value references. */
var Symbol$1 = root.Symbol;

export { Symbol$1 as default };
